<template>
    <Modal
        :title="$t('labels.create_warehouse')"
        ref="modal"
    >
        <div class="modal-body">
            <FormGroup :label="$t('labels.name')">
                <Input v-model="warehouseName" />
            </FormGroup>
        </div>
        <div class="modal-footer">
            <Button size="sm" color="indigo" @click="createWarehouse">
                <span>{{ $t('buttons.create') }}</span>
            </Button>
        </div>
    </Modal>
</template>
<script>
import Modal from '../../../../../components/new/modal/AppModal.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';
import Button from '../../../../../components/new/button/AppButton.vue';
import { httpClient } from '../../../../../services/HttpClient';
export default {
    name: "CreateWarehouseModal",
    components: {
        Modal, FormGroup, Input, Button
    },
    emits: ['created'],
    data() {
        return {
            warehouseName: ''
        }
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        async createWarehouse() {
            await httpClient.post('/management/warehouses', {name: this.warehouseName}).then(() => {
                this.$refs.modal.showed = false;
                this.warehouseName = '';
                this.$emit('created');
            });
        }
    }
}
</script>
